module.exports = __webpack_public_path__ + "static/img/desktop-gis.07314f62.png";